import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { TranslationEn } from '@assets/i18n/en';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
	constructor(private readonly title: Title) {
		super();
	}

	updateTitle(snapshot: RouterStateSnapshot): void {
		const raw = this.buildTitle(snapshot);
		const pageTitle = typeof raw === 'string' ? raw.trim() : '';
		this.title.setTitle(
			pageTitle
				? TranslationEn.pageTitles.titleWithAppName(pageTitle)
				: TranslationEn.pageTitles.appName
		);
	}
}

